import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Anchor, Image } from "hesus-ui-kit";
import AddEditFinacialInformation from "../AddEditFinacialInformation";
import editIcon from "@icons/ic-edit-blue.svg";
import {
  HaulierInfo,
  FlexRow,
  GridRow,
  SubTitle,
  SubTitleBold,
} from "./FinacialInformation.styled";
import "../../SiteView.scss";
import {
  renderPriceWithCurrencyWithoutUnit,
  addSpaceWithoutFloat,
} from "@utils/utils";

const FinacialInformation = (props) => {
  const { t, data, updateRefeshStatus } = props;

  const [isFinancePopUpOpen, setIsFinancePopUpOpen] = useState(false);

  const editSiteFinacialInformation = () => {
    setIsFinancePopUpOpen(true);
  };

  const onFinacialPopUpClose = () => {
    setIsFinancePopUpOpen(false);
  };

  return (
    <HaulierInfo>
      {!!data?.id && (
        <>
          <GridRow column="1fr auto">
            <FlexRow>
              <SubTitleBold>{t("SITE_BUDGET_TYPE")} :</SubTitleBold>
              <SubTitle>
                {data.budgetType === 0 && t("SITE_BUDGET_TYPE_CREDIT_LIMIT")}
                {data.budgetType === 1 && t("SITE_BUDGET_TYPE_SITE_BUDGET")}
                {data.budgetType === 2 &&
                  t("SITE_BUDGET_TYPE_PAYMENT_DELEGATION")}
                {![0, 1, 2].includes(data.budgetType) && "-"}
              </SubTitle>
            </FlexRow>

            <FlexRow>
              <Image
                src={editIcon}
                onClick={editSiteFinacialInformation}
                title={t("SITE_FINANCIAL_INFO_ACTION_TOOLTIP_EDIT")}
                alt={t("SITE_FINANCIAL_INFO_ACTION_TOOLTIP_EDIT")}
                className="site-view-enquiry__image-icon-client_info"
              />
            </FlexRow>
          </GridRow>
          {data.budgetType === 1 && (
            <GridRow column="1fr 1fr">
              <FlexRow>
                <SubTitleBold>{t("SITE_BUDGET_AMOUNT")} :</SubTitleBold>
                <SubTitle>
                  {renderPriceWithCurrencyWithoutUnit(
                    data?.siteBudgetAmount
                      ? addSpaceWithoutFloat(data?.siteBudgetAmount)
                      : "-",
                    data.currency.symbol,
                    data.currency.position
                  )}
                </SubTitle>
              </FlexRow>
            </GridRow>
          )}
          {data.budgetType === 2 && (
            <GridRow column="1fr 1fr">
              <FlexRow>
                <SubTitleBold>{t("SITE_DELEGATION_COMPANY")} :</SubTitleBold>
                <SubTitle>
                  {data.delegatedCompany?.id && (
                    <Anchor
                      url={`/company/view/${data.delegatedCompany?.id}/general-info`}
                      target="_blank"
                      rel="noreferrer"
                      styles={{
                        textDecoration: "underline !important",
                      }}
                    >
                      {data.delegatedCompany?.id +
                        " - " +
                        data.delegatedCompany?.name}
                    </Anchor>
                  )}
                  {!data.delegatedCompany?.id &&
                    data.delegatedCompany?.nameText}
                </SubTitle>
              </FlexRow>
              <FlexRow>
                <SubTitleBold>{t("SITE_DELEGATION_AMOUNT")} :</SubTitleBold>
                <SubTitle>
                  {renderPriceWithCurrencyWithoutUnit(
                    data?.paymentDelegationAmount
                      ? addSpaceWithoutFloat(data?.paymentDelegationAmount)
                      : "",
                    data.currency.symbol,
                    data.currency.position
                  )}
                </SubTitle>
              </FlexRow>
            </GridRow>
          )}
          <GridRow column="1fr 1fr">
            <FlexRow>
              <SubTitleBold>{t("SITE_SUBCONTRACTING")} :</SubTitleBold>
              <SubTitle>
                {data.isSubcontracting ? t("GENERAL_YES") : t("GENERAL_NO")}
              </SubTitle>
            </FlexRow>
            <FlexRow>
              <SubTitleBold>{t("SITE_VAT_RATE")} :</SubTitleBold>
              <SubTitle>
                {data?.invoicingVatRate?.id ? data.invoicingVatRate.name : "-"}
              </SubTitle>
            </FlexRow>
          </GridRow>
          <GridRow column="1fr">
            <FlexRow>
              <SubTitleBold>{t("SITE_PAYMENT_TERMS")} :</SubTitleBold>
              <SubTitle>
                {data.paymentTerms?.id ? data.paymentTerms.name : "-"}
              </SubTitle>
            </FlexRow>
          </GridRow>
          <GridRow column="1fr">
            <SubTitleBold>
              {t("SITE_FINANCIAL_INFORMATION_COMMENT")} :
            </SubTitleBold>

            <SubTitle>
              {data?.financialInfoComment ? (
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.financialInfoComment,
                  }}
                ></div>
              ) : (
                "-"
              )}
            </SubTitle>
          </GridRow>
          {isFinancePopUpOpen && (
            <AddEditFinacialInformation
              onClose={onFinacialPopUpClose}
              site={data}
              updateRefeshStatus={updateRefeshStatus}
            />
          )}
        </>
      )}
    </HaulierInfo>
  );
};

FinacialInformation.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(FinacialInformation);
